module.exports = __webpack_public_path__ + "static/media/double-cta.5f135ed3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cta/double-cta.jpg
// module id = 158
// module chunks = 0